import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-pharmacies',
  imports: [RouterModule],
  templateUrl: './pharmacies.html',
  styleUrl: './pharmacies.scss',
})
export class Pharmacies {}
